import { render, staticRenderFns } from "./TOC.vue?vue&type=template&id=47b9ef6f&scoped=true"
import script from "./TOC.vue?vue&type=script&lang=js"
export * from "./TOC.vue?vue&type=script&lang=js"
import style0 from "./TOC.vue?vue&type=style&index=0&id=47b9ef6f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9ef6f",
  null
  
)

export default component.exports